import VerifiedPerformer from '../../../reusables/svg/offer/VerifiedPerformer.react';
import { InputText } from '../../../reusables';
import { Gtm } from '../../../../utils/gtm';

const PerformerPageModelSelection = ({ trendingPerformers, pname, handleSave }) => (
  <div className="model-selection-box">
    <div className="trending-models">
      <h3>Jerkmate Trending Models</h3>
      <div className="performers">
        {trendingPerformers.map((performer, i) => (
          <div
            className="performer"
            key={i}
            onClick={() => {
              pname.onChange(performer.pname);
              Gtm.event('offersList - performer page', 'Click', `trending: ${performer.pname}`);
            }}
          >
            <div className="performer-img">
              <img alt={performer.name} src={performer.imgUrl} />
            </div>
            <div className="performer-info">
              <span className="name">
                {performer.name} <VerifiedPerformer />
              </span>
              <span className="pname">@{performer.pname}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
    <h4 className="performer-input-title">Cam Model Name</h4>
    <div className="performer-input-box">
      <div className="input-selection">
        <InputText field={pname} id="performer-input" maxLength={40} placeholder="ex: amouranth" tabIndex={10} type="text" />
        <span className="destination">{`Destination: www.jerkmate.com/cam/${pname.value}`}</span>
      </div>
      <div className="performer-action-btns">
        <button
          className="waves-effect btn-large btn-flat cancel-button primary-border-color test-btn"
          onClick={() => {
            window.open(`https://www.jerkmate.com/cam/${pname.value}`, '_blank');
            Gtm.event('offersList - performer page', 'Click', 'test');
          }}
        >
          TEST
        </button>
        <button
          className="waves-effect waves-light btn"
          data-cy="landing-page-save"
          onClick={() => {
            handleSave();
            Gtm.event('offersList - performer page', 'Click', 'select');
          }}
        >
          SELECT
        </button>
      </div>
    </div>
  </div>
);
export default PerformerPageModelSelection;
